// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__SiwfX","resendInfoText":"OnGoingPaymentBox_resendInfoText__3GdRj"};